import { createSlice } from "@reduxjs/toolkit";

const classesSlice = createSlice({
  name: "classes",
  initialState: {
    classesArray:[]
  },
  reducers: {
    getClasses: (state, action) => {
  state.classesArray =action.payload;
 },
 },
});

export const { getClasses } = classesSlice.actions;
export default classesSlice.reducer;